import styled from 'styled-components';

const BookStorePageContainer = styled.div`
  ${({ theme }) => theme.container.mainContainer}
`;

export { BookStorePageContainer };
